import React from 'react'
import img5 from '../../img/img5.jpg'
import '../Projects.css';


function Project2() {

    return (
        <>


            <div className='container-projects'>
                <img src={img5} />
                <div className='project-description'>
                    <h2 className='titulo-projects'>Renovation </h2>
                    The remodeling of the stairs at "Casa de los Pérez" was carried out with the aim of enhancing both the functionality and aesthetics of this central area of the home. The project involved a complete renovation that encompassed everything from the structure and materials to the finishes and decoration, with a focus on safety, durability, and modern design.
                    <h1>Renovation Details:</h1>
                    <h1>Initial Evaluation and Planning:</h1><br></br>
                    Technical Inspection: A detailed inspection of the existing stairs was conducted to identify structural issues, wear and tear, and areas needing updates. This included the evaluation of the railing, steps, and supports.<br></br><br></br>
                    Design and Planning: In collaboration with the homeowners, a design was developed that combined functionality and aesthetics. Several design and material options were presented, taking into account style preferences and the available budget.
                </div>

            </div>
        </>
    )



}

export default Project2